/**
 * Sentinel value for "Auto" default note template in session settings.
 * When user selects "Auto" in Default note template dropdown, this value is
 * stored in session_settings.default_template_id. The backend should persist it
 * and use it to create new sessions with AUTO_MODE generation.
 */
export const DEFAULT_TEMPLATE_AUTO_MODE = 'AUTO_MODE';
